<template>
  <div id='page_Container'>
        <div id="main-container" class='main-container'>
            <div id="after-sales-list">
                <van-tabs swipeable @change="tabChange" v-model="tabCurrentIndex">
                    <van-tab v-for="item in tabsConfig" :title="item.title" :key="item.index">
                        <van-pull-refresh :class="{afterSalesListBox:!listShow}" v-model="isLoading" @refresh="onRefresh" class='refreshBox' >
                            <van-list
                                v-model="ploading"
                                :finished="finished"
                                finished-text="没有更多了"
                                @load="onLoad"
                                v-if='listShow'
                            >
                                <div class='afterSalesList' v-for='item in listData' :key='item.id'>
                                    <div class='afterSalesType'>
                                            <div>
                                                <img :src="refundUrl" alt="">
                                                <div class='spanType'>{{item.typeStr}}</div>
                                            </div>

                                            <span>{{item.statusStr}}</span>
                                    </div>
                                    <van-card :title="ele.productName" :thumb="ele.productImg" v-for="(ele, index) in item.itemList" :key="index">
                                        <template slot='desc'>
                                            <p class='descP'>{{ele.specificationValue}}</p>
                                            <div class='numP'>
                                                <div>¥{{ele.amount}}</div>
                                                <span>×{{ele.quantity}}</span>
                                            </div>
                                        </template>
                                    </van-card>

                                    <div class='btnStyle'>
                                        <van-button round @click='openGoodDetails(item)'>查看详情</van-button>
                                    </div>
                                </div>
                            </van-list>
                            <noData v-else></noData>
                        </van-pull-refresh>
                    </van-tab>

                </van-tabs>
            </div>
        </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
export default {
    data() {
        return {
            tabsConfig: [
                { title: '退货', index: '1' },
                { title: '售后', index: '2' }
            ],
            params: {
                pageSize: 10
            },
            tabCurrentIndex: 0,
            refundUrl: require('../assets/img/myCenter/refund.png'),
            pageNum: 1,
            queryType: this.$route.query.type,
            listData: [],
            listShow: false,
            ploading: false,
            finished: true,
            isLoading: false
        };
    },
    esvShow(data) {
        if (this.queryType === 'order') {
            this.params.orderCode = this.orderDetails.orderCode;
            this.params.orderItemId = this.orderDetails.memberOrderItemList[0].id;
        }
        this.listData = [];
        this.queryData(1);
    },
    methods: {
        ...mapMutations(['setChoiceGoodsItem']),
        queryAppointmentRecords(params) {
            this.$doRequest(
                {
                    url: '/appoint/queryAppointmentRecords',
                    params: params,
                    before: () => {
                        this.loading = toastLoading();
                    },
                    complete: () => {
                        clearToastLoading(this.loading);
                    }
                },
                (data) => {
                    const listData = this.setData(data.result.list);
                    this.listData = [ ...this.listData, ...listData ];
                    this.isFinished(this.listData.length, data.result.total);
                    this.isLoading = false;
                    this.ploading = false;
                }
            );
        },
        queryMemberOrderRefundList(params) {
            this.$doRequest(
                {
                    url: '/refund/queryMemberOrderRefundList',
                    params: params,
                    before: () => {
                        this.loading = toastLoading();
                    },
                    complete: () => {
                        clearToastLoading(this.loading);
                    }
                },
                (data) => {
                    const listData = this.setData(data.result.list);
                    this.listData = [ ...this.listData, ...listData ];
                    this.isFinished(this.listData.length, data.result.total);
                    this.isLoading = false;
                    this.ploading = false;
                }
            );
        },
        openGoodDetails(item) {
            this.setChoiceGoodsItem({ choiceGoodsItem: item.itemList[0] });
            if (item.open === 'afterSales') {
                this.esvOpenPage({ name: 'OPAfterSalesDetails', query: { type: item.appointmentType === 2 ? 'install' : 'repair', appointId: item.id } });
            } else {
                const params = {
                    refundCode: item.refundCode
                };
                this.$doRequest(
                    {
                        url: '/refund/queryMemberOrderRefundDetail',
                        params: params,
                        before() {
                            this.loading = toastLoading();
                        },
                        complete() {
                            clearToastLoading(this.loading);
                        }
                    },
                    (data) => {
                        this.ESVStorage.putSavedValue(
                            'refundSuccessData',
                            data.result
                        );
                        this.esvOpenPage('OPReturnGoodsDetails');
                    }
                );
            }
        },
        onLoad() {
            this.pageNum++;
            this.queryData(this.pageNum);
        },
        isFinished(length, total) {
            if (length < total) {
                this.finished = false;
            } else {
                this.finished = true;
            }

            if (length > 0) {
                this.listShow = true;
            } else {
                this.listShow = false;
            }
        },
        tabChange(index) {
            this.finished = true;
            this.tabCurrentIndex = index;
            this.onRefresh();
        },
        queryData(pageNum) {
            const index = this.tabCurrentIndex;
            if (index === 1) {
                this.queryAppointmentRecords({ pageNum, ...this.params });
            } else {
                this.queryMemberOrderRefundList({ pageNum, ...this.params });
            }
        },
        onRefresh() {
            this.listData = [];
            this.pageNum = 1;
            this.queryData(1);
        },
        setData(data) {
            console.log(data);
            const listData = [];
            // 退货
            if (this.tabCurrentIndex === 0) {
                data.forEach(ele => {
                    listData.push({
                        status: ele.status,
                        open: 'refund',
                        statusStr: ele.statusStr,
                        typeStr: ele.typeStr,
                        refundCode: ele.refundCode,
                        itemList: ele.memberOrderRefundItemList
                    });
                });
            } else {
                // 售后
                data.forEach(ele => {
                    const { productImg, orderCode, productName, mallDiscountAmount, quantity, specificationValue, orderItemAmount } = ele;
                    listData.push({
                        status: ele.appointmentStatus,
                        statusStr: ele.appointmentStatusDesc,
                        typeStr: ele.appointmentTypeDesc,
                        appointmentType: ele.appointmentType,
                        open: 'afterSales',
                        id: ele.id,
                        itemList: [{
                            productImg,
                            amount: orderItemAmount,
                            specificationValue,
                            orderCode,
                            productName: productName || 0,
                            mallDiscountAmount: mallDiscountAmount || 0,
                            quantity: quantity || 1
                        }]
                    });
                });
            }
            console.log(listData);
            return listData;
        }
    },
    computed: {
        ...mapState({ orderDetails: state => state.order.orderDetails })
    },
    components: {
        noData: () => import('@/components/base/noData')
    }
};
</script>

<style lang="scss">
#after-sales-list {
    height: 100%;
    .afterSalesListBox {
        display: flex;
        align-items: center; /*垂直居中*/
        justify-content: center; /*水平居中*/
        height: 100%;
    }
    .afterSalesList:first-child {
            margin-top: 10px;
        }
    .btnStyle {
        text-align: right;
        padding: 8px 16px;
        background-color: #fff;
        .van-button--default {
            border: 1px solid #ee2e50;
        }
        .van-button {
            height: 30px;
            line-height: 30px;
            font-size: 12px;
            padding: 0 12px;
            .van-button__text {
                color: #ee2e50 !important;
            }
        }
    }
    .afterSalesType {
        padding: 7px;
        line-height: 22px;
        border-bottom: 1px solid #f3f2f2;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        >div {
            display: flex;
        }
        span {
            color: $primary-color
        }
        .spanType {
            padding-left: 7px;
        }
        img {
            width: 22px;
            height: 22px;
            flex: none;
            display: block;
        }
        p {
            height: 40px;
            line-height: 40px;
            flex-direction: row;
            align-items: center;
            /*垂直居中*/
            display: flex;
        }
    }
    .van-card:not(:first-child) {
        margin-top: 0
    }
    .van-card__thumb {
        width: 80px;
        height: 80px;
        img {
            width: 100%;
        }
    }
    .numP {
        display: flex;
        justify-content: space-between;
        >div {
            color: $primary-color;
            font-size: 14px;
        }
    }
}
</style>
